/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Section_DescriptionInputs */

const fr_totp_section_description = /** @type {(inputs: Totp_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoute une couche de sécurité supplémentaire à ton compte en utilisant une application d'authentification.`)
};

/**

* @param {Totp_Section_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_section_description = /** @type {((inputs?: Totp_Section_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Section_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_section_description(inputs)
});